import React from "react";
import HamburgerBar from "../HamburgerBar";

function PageWithSidebar({
  children,
  sidebar,
}: {
  children: React.ReactNode;
  sidebar: React.ReactNode;
}) {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <div className="md:flex">
      <HamburgerBar
        onToggle={() => setSidebarOpen(!sidebarOpen)}
        isOpen={sidebarOpen}
      ></HamburgerBar>

      <div
        className={sidebarOpen ? "" : "hidden md:block"}
        onClick={() => {
          setSidebarOpen(false);
        }}
      >
        {sidebar}
      </div>

      <div className="w-full">{children}</div>
    </div>
  );
}

export default PageWithSidebar;
